import { React, useState, useEffect } from "react";
import { Input, Segmented } from "antd";
import {
  useNavigate,
  useSearchParams,
  useLocation,
  useParams,
} from "react-router-dom";

import useRoleCheck from "utilities/hooks/roleCheck";

import RequestTable from "./components/RequestTable";
import RequestDetails from "./components/RequestDetails";

import ForbiddenScreen from "pages/403";

const Requests = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { hasPermission } = useRoleCheck();

  const fromRequestsPage = location.state?.fromRequestsPage || false;

  const search = searchParams.get("search") || "";
  const status = searchParams.get("status") || "";

  const [inputValue, setInputValue] = useState(search);
  const [statusValue, setStatusValue] = useState(status);

  const { request_id } = useParams();

  useEffect(() => {
    if (location.pathname === "/equipment/requests") {
      const handler = setTimeout(() => {
        var status = statusValue.trim() ? { status: statusValue } : {};
        var search = inputValue.trim() ? { search: inputValue } : {};

        setSearchParams({ ...status, ...search }, { replace: true });
      }, 200);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [inputValue, statusValue, setSearchParams, location.pathname]);
  if (
    !hasPermission([
      "Operations",
      "IT",
      "Marketing",
      "Sales.RM",
      "Sales.Exec",
      "Audiology",
    ])
  ) {
    return <ForbiddenScreen />;
  }

  return (
    <>
      <div className="p-8">
        <div className="flex">
          <Input.Search
            placeholder="Search Equipment Inventory"
            allowClear
            size="large"
            suffix=""
            onChange={(event) => setInputValue(event.target.value)}
            value={inputValue}
            className="mr-2"
          />
          <Segmented
            options={[
              { label: "All", value: "" },
              { label: "Submitted", value: "Submitted" },
              { label: "Approved", value: "Approved" },
              { label: "Shipped", value: "Shipped" },
              { label: "Rejected", value: "Rejected" },
            ]}
            value={statusValue}
            onChange={(value) => setStatusValue(value)}
          />
        </div>

        <div className="mt-4">
          <RequestTable
            search={search}
            status={status}
            openModal={(id) => {
              navigate(`${id}`, { state: { fromRequestsPage: true } });
            }}
          />
        </div>
      </div>

      <RequestDetails
        id={request_id}
        open={location.pathname === `/equipment/requests/${request_id}`}
        onClose={() => navigate(fromRequestsPage ? -1 : "/equipment/requests")}
      />
    </>
  );
};

export default Requests;
